export default __webpack_public_path__ + "static/media/credit-card.7865e1a8.svg";